// Removed hacky protection - fixing root cause in build config instead

import { createRoot } from "react-dom/client";
import React from "react";
import App from "./App";
import "./index.css";

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

// Add error handling for initialization
try {
  // Verify createRoot is available
  if (typeof createRoot !== 'function') {
    throw new Error('createRoot is not a function. This may indicate a bundling issue.');
  }
  
  const root = createRoot(rootElement);
  
  // Verify App is a valid component
  if (!App || typeof App !== 'function') {
    throw new Error('App component is not valid. This may indicate a bundling issue.');
  }
  
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error("Failed to render app:", error);
  console.error("Error details:", {
    name: error instanceof Error ? error.name : 'Unknown',
    message: error instanceof Error ? error.message : String(error),
    stack: error instanceof Error ? error.stack : undefined,
    createRootType: typeof createRoot,
    AppType: typeof App,
  });
  
  rootElement.innerHTML = `
    <div style="padding: 20px; font-family: sans-serif; max-width: 800px; margin: 0 auto;">
      <h1 style="color: #dc2626;">Application Error</h1>
      <p>Failed to initialize the application. This may be due to a bundling or minification issue.</p>
      <div style="background: #f5f5f5; padding: 15px; border-radius: 4px; margin: 15px 0; overflow: auto;">
        <strong>Error:</strong>
        <pre style="margin: 10px 0; white-space: pre-wrap; word-break: break-word;">
${error instanceof Error ? error.message : String(error)}
        </pre>
        ${error instanceof Error && error.stack ? `
        <strong>Stack:</strong>
        <pre style="margin: 10px 0; white-space: pre-wrap; word-break: break-word; font-size: 12px;">
${error.stack}
        </pre>
        ` : ''}
      </div>
      <div style="margin-top: 20px;">
        <button onclick="window.location.reload()" style="padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 16px;">
          Refresh Page
        </button>
        <button onclick="localStorage.removeItem('REACT_QUERY_OFFLINE_CACHE'); localStorage.clear(); sessionStorage.clear(); window.location.reload();" style="padding: 10px 20px; background: #6c757d; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 16px; margin-left: 10px;">
          Clear Cache & Refresh
        </button>
      </div>
    </div>
  `;
}
